import type { MessageSchema } from "./zh";

const messages: MessageSchema = {
  common: {
    appName: "Jzbro Cloud",
    appNameGlobal: "Starparks",
    confirm: "OK",
    cancel: "Batal",
    loginRegister: "Masuk / Daftar",
    userAgreement: "Ketentuan Layanan",
    privacyPolicy: "Kebijakan Privasi",
    notBound: "Belum diatur",
  },
  tabbar: {
    home: "Beranda",
    search: "Cari",
    library: "Pustaka",
    mine: "Saya",
    badgeLogin: "Masuk",
    badgeUpgrade: "VIP",
  },
  login: {
    navTitle: "Masuk",
    welcome: "Selamat datang di {brand}",
    subtitle: "Masuk dengan kode SMS, atau gunakan WeChat / QQ",
    subtitleGlobal: "Main langsung sebagai tamu, atau masuk dengan Google",
    mobileLabel: "Ponsel",
    mobilePlaceholder: "Nomor ponsel",
    codeLabel: "Kode",
    codePlaceholder: "Kode SMS",
    getCode: "Dapatkan kode",
    resendIn: "Kirim ulang dalam {sec}dtk",
    agreement:
      "Nomor yang belum terdaftar akan otomatis dibuatkan akun. Dengan melanjutkan, Anda menyetujui {userAgreement} dan {privacyPolicy}",
    otherMethods: "Cara masuk lainnya",
    guest: "Lanjutkan sebagai tamu",
    wechat: "Masuk dengan WeChat",
    qq: "Masuk dengan QQ",
    google: "Lanjutkan dengan Google",
    telegram: "Lanjutkan dengan Telegram",
    facebook: "Lanjutkan dengan Facebook",
    wechatComingSoon: "Masuk WeChat segera hadir",
    qqComingSoon: "Masuk QQ segera hadir",
    googleComingSoon: "Masuk Google segera hadir",
    googleFailed: "Masuk Google gagal, silakan coba lagi",
    telegramFailed: "Login Telegram gagal, silakan coba lagi",
    facebookComingSoon: "Masuk Facebook segera hadir",
    mobileInvalid: "Masukkan nomor ponsel yang valid",
    codeInvalid: "Masukkan kode verifikasi",
    codeSent: "Kode terkirim",
  },
  loginPrompt: {
    defaultMessage: "Masuk untuk melihat game Anda",
  },
  settings: {
    navTitle: "Pengaturan",
    loginPrompt: "Masuk untuk mengelola pengaturan akun",
    nickname: "Nama panggilan",
    mobile: "Ponsel",
    controller: "Pengaturan kontroler",
    controllerDesc: "Sensitivitas mouse / stik kanan / tukar tombol",
    about: "Tentang",
    clearCache: "Bersihkan cache lokal",
    language: "Bahasa",
    editNickname: "Ubah nama panggilan",
    nicknamePlaceholder: "Nama panggilan baru",
    nickEmpty: "Nama panggilan tidak boleh kosong",
    nickTooLong: "Nama panggilan maksimal 16 karakter",
    updated: "Diperbarui",
    cacheCleared: "Cache dibersihkan. Silakan masuk lagi",
    aboutTitle: "Tentang {brand}",
    aboutVersion: "Versi web v{version}",
    aboutBody:
      "Cloud gaming yang membuat Anda bisa memainkan game AAA langsung di browser, di mana saja.\nSemua konten game adalah milik penerbitnya masing-masing.",
  },
  subscription: {
    choosePlan: "Pilih paket",
    included: "Yang termasuk",
    orderSummary: "Ringkasan pesanan",
    total: "Total",
    continue: "Lanjutkan",
    secureNote: "Pembayaran aman · Pembelian satu kali",
    navTitle: "Tingkatkan",
    unlockTitle: "Buka hak istimewa anggota",
    expired: "Kedaluwarsa",
    daysLeft: "Sisa {days} hari",
    validUntil: "Berlaku sampai {time}",
    tagline: "Tanpa antre, sesi lebih lama, kualitas lebih tinggi",
    perDay: "Sekitar {price}/hari",
    recommended: "Nilai terbaik",
    currentLevel: "Paket saat ini",
    footer:
      "Ini adalah pembelian keanggotaan satu kali. Durasi yang dipilih ditambahkan setelah pembayaran dikonfirmasi dan tidak akan diperpanjang otomatis.",
    planVipMonth: "VIP Bulanan",
    planSvipMonth: "SVIP Bulanan",
    perkNoQueue: "Lewati antrean",
    perkDailyFree: "60 menit gratis setiap hari",
    perkHd: "Kualitas HD",
    perkAllVip: "Semua hak istimewa VIP",
    perkUnlimited: "Waktu bermain tanpa batas",
    perk4k: "4K / 60fps",
    perkSupport: "Dukungan prioritas",
    cnPayComingSoon:
      "Pembayaran WeChat / Alipay di web segera hadir — silakan gunakan aplikasi untuk saat ini",
    intlPayComingSoon: "Pembayaran Stripe / PayPal segera hadir",
    payProcessing: "Selesaikan pembayaran dan biarkan halaman ini tetap terbuka…",
    paySuccess: "Pembayaran berhasil — keanggotaan diaktifkan",
    payFailed: "Pembayaran gagal, silakan coba lagi",
    payCancelled: "Pembayaran dibatalkan",
    telegramExtraTimeUnavailable: "Pembelian waktu bermain di Telegram akan tersedia setelah versi Stars ditambahkan.",
    payUnconfirmed:
      "Pembayaran belum terkonfirmasi; jika sudah membayar, akan segera dikreditkan",
    payPopupBlocked:
      "Jendela pembayaran diblokir — izinkan pop-up lalu coba lagi",
    loadPlansFailed: "Gagal memuat paket, silakan coba lagi",
    retry: "Coba lagi",
  },
  download: {
    nav: "Download App",
    title: "Get the Starparks app",
    subtitle: "Play Starparks on your phone and purchase membership in the app.",
    androidDescription: "The Android app is available on Google Play.",
    googlePlay: "Get it on Google Play",
    iosDescription: "The iOS app is on its way.",
    comingSoon: "Coming soon",
    membershipUnavailable: "Membership is not available yet",
    membershipAppHint: "Membership purchases are not available on this website. Please use the app to purchase a membership.",
    goToDownload: "Go to download page",
  },
  app: {
    backToDesktop: "Kembali ke desktop",
  },
  titles: {
    download: "Download App",
    home: "Beranda",
    search: "Cari",
    detail: "Detail game",
    library: "Pustaka",
    category: "Kategori",
    mine: "Saya",
    myGames: "Game saya",
    reviews: "Ulasan",
    gameVideos: "Video gameplay",
    commentReplies: "Komentar",
    saves: "Penyimpanan",
    subscription: "Tingkatkan",
    signIn: "Check-in harian",
    settings: "Pengaturan",
    controlSettings: "Pengaturan kontroler",
    login: "Masuk",
    play: "Bermain",
  },
  home: {
    searchPlaceholder: "Cari game",
    sectionDefault: "Game",
    allGames: "Semua game",
    more: "Lainnya",
    empty: "Belum ada apa pun di sini",
    latestOnline: "Rilis baru",
    comingSoon: "Segera hadir",
    subscribe: "Beri tahu saya",
    subscribed: "Sudah dipesan",
    score: "Rating",
    subscribeSuccess: "Berhasil dipesan — kami beri tahu saat rilis",
  },
  nav: {
    home: "Beranda",
    library: "Pustaka",
    searchPlaceholder: "Cari game",
    me: "Saya",
    guest: "Tamu",
    profile: "Profil",
    myGames: "Game saya",
    dailyCheckIn: "Check-in harian",
    renewMembership: "Perpanjang keanggotaan",
    upgradeMembership: "Tingkatkan keanggotaan",
    settings: "Pengaturan",
    switchToMobile: "Beralih ke seluler",
    logout: "Keluar",
    logoutConfirm: "Yakin ingin keluar?",
    mobileVersion: "Seluler",
    login: "Masuk",
  },
  library: {
    all: "Semua",
    noMore: "Tidak ada lagi",
    loading: "Memuat…",
    noData: "Tidak ada data",
    noGames: "Tidak ada game",
    noUpcoming: "Tidak ada game mendatang",
    emptyCategory: "Tidak ada game di kategori ini",
  },
  mine: {
    notLoggedIn: "Belum masuk",
    loginSyncTip: "Masuk untuk menyinkronkan keanggotaan, favorit, dan riwayat game",
    loginSyncTipDesktop:
      "Masuk untuk melihat profil, keanggotaan, check-in, dan riwayat game",
    guest: "Tamu",
    daysLeft: "Sisa {n} hari",
    expired: "Kedaluwarsa",
    renewBanner: "{level} Anda berakhir dalam {n} hari — perpanjang diskon 30%",
    membershipExpiredRenew: "Keanggotaan Anda telah kedaluwarsa — perpanjang sekarang",
    membershipExpired: "Keanggotaan kedaluwarsa",
    membershipDaysLeft: "Sisa {n} hari keanggotaan",
    gameTime: "Waktu bermain",
    minUnit: "mnt",
    dailyCheckIn: "Check-in harian",
    upgrade: "Tingkatkan",
    renew: "Perpanjang",
    upgradeMembership: "Tingkatkan keanggotaan",
    renewMembership: "Perpanjang keanggotaan",
    membership: "Keanggotaan",
    myCollection: "Favorit saya",
    collectedGames: "Game tersimpan",
    recentlyPlayed: "Baru dimainkan",
    gameHistory: "Riwayat game",
    settings: "Pengaturan",
    switchToDesktop: "Beralih ke desktop",
    accountAndPrefs: "Akun & preferensi",
    claimGameTime: "Dapatkan waktu bermain",
    bindPhone: "Ikat nomor ponsel",
    bindPhoneDesc: "Tingkatkan ke akun penuh dan sinkronkan antar perangkat",
    bindPhoneDescDesktop: "Tingkatkan ke akun penuh, sinkronkan antar perangkat",
    resetGuest: "Setel ulang identitas tamu",
    resetGuestDesc: "Hapus akun tamu ini dan mulai dari awal",
    resetGuestDescDesktop: "Mulai dari awal dengan identitas baru",
    logout: "Keluar",
    myGamesTitle: "Game saya",
    collectTab: "Favorit",
    loginViewCollect: "Masuk untuk melihat game tersimpan Anda",
    noCollect: "Belum ada game tersimpan",
    loginViewHistory: "Masuk untuk melihat riwayat game Anda",
    noHistory: "Belum ada game yang dimainkan baru-baru ini",
    weekMon: "Sen",
    weekTue: "Sel",
    weekWed: "Rab",
    weekThu: "Kam",
    weekFri: "Jum",
    weekSat: "Sab",
    weekSun: "Min",
    alreadySignedToday: "Sudah check-in hari ini",
    signSuccessReward: "Check-in! +{n} mnt",
    signSuccess: "Check-in berhasil",
    loginJoinCheckIn: "Masuk untuk ikut check-in harian",
    claimed: "Diklaim",
    unclaimed: "Terlewat",
    todayDone: "Hari ini ✓",
    today: "Hari ini",
    dayN: "Hari {n}",
    signedToday: "Sudah check-in hari ini",
    signNow: "Check-in sekarang",
    checkInTip1: "Check-in setiap hari untuk mendapatkan waktu bermain gratis.",
    checkInTip2: "Hari yang terlewat bisa diganti dengan koin di halaman susulan.",
    loggedOut: "Telah keluar",
    resetGuestConfirm:
      "Ini akan menghapus akun tamu saat ini dan memulai ulang dengan identitas baru. Langganan, favorit, dan riwayat yang dibeli akan hilang semua. Lanjutkan?",
    resetGuestConfirmBtn: "Reset",
    resetting: "Mereset…",
    resetDone: "Reset selesai — silakan masuk lagi",
  },
  reviews: {
    recommendRate: "rekomendasi",
    tooFew: "Ulasan masih sedikit",
    count: "{n} ulasan",
    playFirst: "Mainkan dulu untuk menulis ulasan",
    rateThis: "Sudah main? Beri ulasan",
    mine: "Punyaku",
    edit: "Edit",
    delete: "Hapus",
    report: "Laporkan",
    played: "Main {d}",
    contentEmpty: "Ulasan tidak boleh kosong",
    editReview: "Edit ulasan",
    editDone: "Diperbarui",
    published: "Ulasan terkirim",
    deleteTitle: "Hapus ulasan?",
    deleteConfirm: "Tindakan ini permanen. Hapus ulasan ini?",
    deleted: "Dihapus",
    reportTitle: "Laporkan",
    reportConfirm: "Laporkan konten ini? Tim kami akan meninjau.",
    reported: "Dilaporkan",
    deleteReplyTitle: "Hapus balasan?",
    deleteReplyConfirm: "Hapus balasan ini?",
    replyTo: "membalas",
    viewAllReplies: "Lihat semua {n} balasan",
    loadMore: "Muat lebih banyak",
    allReplies: "Semua balasan ({n})",
    commentDeleted: "Ulasan ini telah dihapus",
    commentShielded: "Ulasan ini disembunyikan",
    replyDeleted: "Balasan ini telah dihapus",
    replyShielded: "Balasan ini disembunyikan",
  },
  detail: {
    svipRequiredMsg: "Game ini memerlukan SVIP untuk dimainkan",
    timeInsufficientMsg: "Waktu game tidak cukup. Harap beli waktu game terlebih dahulu.",
    goBuy: "Beli Sekarang",
    thinkAgain: "Pikir lagi",
    navTitle: "Detail game",
    back: "Kembali",
    svipOnly: "Khusus SVIP",
    vipOnly: "Khusus VIP",
    freeMinutes: "{n} mnt gratis",
    saveManage: "Penyimpanan",
    saveManageDesc: "Lihat / pulihkan penyimpanan lama dan tambah catatan",
    liveVideos: "Video gameplay",
    more: "Lainnya",
    viewAll: "Lihat semua",
    viewAllCount: "Lihat semua {n}",
    intro: "Tentang game ini",
    screenshots: "Tangkapan layar",
    controlMethod: "Kontrol: ",
    playerReviews: "Ulasan",
    commentCount: "{n}",
    recommend: "Rekomendasikan",
    notRecommend: "Tidak direkomendasikan",
    similarGames: "Game serupa",
    collect: "Favoritkan",
    collected: "Difavoritkan",
    collectStar: "☆ Favoritkan",
    collectedStar: "★ Difavoritkan",
    unfavorited: "Dihapus dari favorit",
    entering: "Masuk…",
    unlockSvip: "Buka dengan SVIP",
    unlockVip: "Buka dengan VIP",
    startGame: "Main",
    reviewCount: "{n} ulasan",
    sortHot: "Teratas",
    sortNew: "Terbaru",
    noMore: "Tidak ada lagi",
    playedHours: "Bermain {n} jam",
    report: "Laporkan",
    reportTitle: "Laporkan komentar ini?",
    reportMessage: "Moderator kami akan meninjaunya. Laporkan?",
    reported: "Dilaporkan",
    noReviews: "Belum ada ulasan — jadilah yang pertama",
    writeReview: "Tulis ulasan",
    reviewPlaceholder: "Bagikan pengalaman Anda… (minimal 5 karakter)",
    reviewMinLength: "Ulasan minimal 5 karakter",
    reviewSubmitted: "Ulasan terkirim",
    publish: "Terbitkan",
    commentDetail: "Komentar",
    replyCount: "{n} balasan",
    noReplies: "Belum ada balasan — jadilah yang pertama",
    reply: "Balas",
    replyToUser: "Balas ke {'@'}{name}",
    saySomething: "Tulis sesuatu…",
    send: "Kirim",
    sent: "Terkirim",
    videoCount: "{n} video",
    watchCount: "{k}rb tayangan",
    noVideos: "Belum ada video",
    videoUnavailable: "Video ini tidak dapat diputar saat ini",
    videoUnavailableDesc: "Mungkin klip lama yang sudah dihapus — coba yang lain",
  },
  search: {
    placeholder: "Masukkan nama game",
    emptyHint: "Cari berdasarkan nama game atau pinyin",
    history: "Pencarian terakhir",
    clear: "Bersihkan",
    noResults: "Game tidak ditemukan",
  },
  misc: {
    savesTitle: "Penyimpanan Game",
    savesTitleNamed: "{name} - Penyimpanan",
    savesLoginPrompt: "Masuk untuk melihat penyimpanan game Anda",
    savesActiveHeading: "Penyimpanan aktif",
    savesUnnamed: "Penyimpanan tanpa nama",
    savesEditRemark: "Ganti nama",
    savesEmpty: "Belum ada penyimpanan cloud",
    savesEmptyHint: "Penyimpanan yang dibuat dalam game tersinkron ke sini otomatis",
    savesHistory: "Riwayat",
    savesCount: "{n} penyimpanan",
    savesCurrent: "Saat ini",
    savesCorrupted: "Rusak",
    savesRestore: "Pulihkan",
    savesNoHistory: "Tidak ada riwayat penyimpanan",
    savesFooter:
      "Penyimpanan dipicu oleh simpan manual / otomatis dalam game dan tersinkron ke cloud secara otomatis. Penghapusan manual belum didukung untuk saat ini (terus menyimpan dalam game akan menimpa yang paling lama).",
    savesRemarkTitle: "Ubah catatan penyimpanan",
    savesRemarkPlaceholder: "Beri nama penyimpanan ini, mis. \"Selesai Bab 1\"",
    savesSave: "Simpan",
    savesAlreadyCurrent: "Ini sudah jadi penyimpanan saat ini",
    savesRestoreTitle: "Pulihkan penyimpanan",
    savesRestoreConfirm:
      "Pulihkan ke penyimpanan ini? Saat berikutnya diluncurkan, game dimulai dari \"{name}\".",
    savesSwitched: "Beralih ke penyimpanan ini",
    savesSaved: "Tersimpan",
    ctrlNavTitle: "Pengaturan Kontroler",
    ctrlSave: "Simpan",
    ctrlIntro:
      "Sesuaikan rasa mouse / gamepad di sini. Membiarkan nilai apa pun kosong / 0 mengikuti default server tiap game; perubahan berlaku untuk semua game.",
    ctrlMouseSensitivity: "Sensitivitas mouse",
    ctrlServerDefault: "Default server",
    ctrlMouseHint: "Dalam mode terkunci, jarak gerak = gerakan fisik × {n}%",
    ctrlStickSensitivity: "Sensitivitas stik kanan",
    ctrlStickHint:
      "Kecepatan putar bidik untuk game FPS / aksi. Stik kiri (gerak) tidak terpengaruh.",
    ctrlPrimaryClick: "Tombol mouse utama",
    ctrlLeftPrimary: "Kiri utama",
    ctrlRightPrimary: "Kanan utama",
    ctrlPrimaryClickHint:
      "Beberapa game (mis. sejumlah judul indie) menembak dengan klik kanan secara default dan perlu ditukar.",
    ctrlResetDefault: "Setel ulang",
    ctrlSavedToast: "Tersimpan, berlaku saat berikutnya diluncurkan",
    ctrlResetToast: "Dipulihkan ke konfigurasi server",
    savesUploading: "Penyimpanan sedang diunggah — coba lagi sebentar lagi",
    savesCheckFailed: "Gagal memeriksa status penyimpanan — coba lagi",
  },
  play: {
    stageReady: "Siap",
    queueing: "Dalam antrean",
    queueJoining: "Bergabung ke antrean…",
    queueAheadPrefix: "",
    queueAheadSuffix: "pemain di depan Anda",
    queueEta: "sekitar {n}dtk",
    cancelReturn: "Batal dan kembali",
    back: "Kembali",
    retry: "Coba lagi",
    goSubscribe: "Tingkatkan",
    entering: "Masuk ke game",
    vipCta: "Tingkatkan ke VIP untuk masuk sekarang",
    vipPerks: "Tanpa antre + kualitas HD + sesi lebih lama",
    sessionExpiredHint:
      "Sesi biasanya kedaluwarsa setelah menunggu lama — ketuk \"Coba lagi\" untuk mengantre lagi",
    lineOldUser: "Antrean pemain lama",
    lineNewbie: "Antrean pemain baru",
    lineFast: "Antrean jalur cepat",
    lineSvip: "Antrean SVIP",
    svipRequired: "Game ini khusus SVIP. Silakan tingkatkan ke SVIP dulu",
    stageConnectingServer: "Menghubungkan ke server…",
    stageHandshake: "Berjabat tangan dengan server…",
    stageP2pNegotiating: "Menegosiasikan saluran P2P…",
    stageMediaStreaming: "Mengalirkan media…",
    stageWaitingFrame: "Menunggu video…",
    stageVideoTrack: "Trek video diterima…",
    stageEntered: "Terhubung",
    stageConnect: "Koneksi",
    stageConnectedSoon: "Terhubung — video akan segera muncul…",
    allocFailed: "Tidak dapat mengalokasikan server game",
    allocFailedHttp: "Alokasi gagal (HTTP {status})",
    reenterHint: " (silakan keluar dan masuk kembali ke game)",
    errP2pFailed: "Negosiasi P2P gagal. Silakan periksa jaringan Anda",
    errDisconnected: "Koneksi terputus (code={code}). Silakan coba lagi",
    errStageFailed: "{stage} gagal",
    errStageFailedDetail: "{stage} gagal: {detail}",
    errConnectTimeout:
      "Koneksi habis waktu — tidak dapat menjangkau server. Periksa jaringan dan coba lagi",
    errQueueCancelled: "Server membatalkan antrean Anda. Silakan coba lagi",
    errKicked:
      "Akun Anda masuk di perangkat lain, sehingga sesi ini terputus",
    errCannotStart: "Tidak dapat memulai game saat ini",
    registerFailed: "Registrasi gagal",
  },
  game: {
    recharge: "Isi ulang",
    tabControl: "Kontrol",
    tabFrame: "Tampilan",
    tabVoice: "Suara",
    controlScheme: "Mode kontrol",
    hideVirtualKeys: "Sembunyikan tombol virtual",
    mouseMode: "Mode mouse",
    mouseModeTouchpad: "Touchpad",
    mouseModeDrag: "Seret",
    mouseModeDirect: "Langsung",
    mouseSensitivity: "Sensitivitas mouse {n}%",
    rightStickMode: "Mode stik kanan",
    joyModeFixed: "Tetap",
    joyModeHalf: "Setengah layar",
    joyModeFull: "Layar penuh",
    joyModeDrag: "Seret",
    stickSensitivity: "Sensitivitas stik {n}%",
    customLayout: "Tata letak tombol kustom",
    editLayout: "Edit tata letak",
    frameComingSoon:
      "Penskalaan tampilan / pengalihan kualitas hadir di versi mendatang.",
    gameSound: "Suara game",
    schemeFollow: "Ikuti game",
    schemeGamepad: "Gamepad",
    schemeKeyMouse: "Keyboard & mouse",
    schemeTouch: "Sentuh",
    schemeSwitchedGamepad: "Beralih ke gamepad",
    schemeSwitchedKeyMouse: "Beralih ke keyboard & mouse",
    schemeSwitchedFollow: "Dipulihkan ke ikuti game",
    modifierTitle: "Modifier",
    modifierNeedUnlock: "Modifier ini harus dibeli untuk dibuka",
    usageTitle: "Petunjuk",
    usageEmpty: "Belum ada petunjuk",
    gotIt: "Mengerti",
    close: "Tutup",
    noModifiers: "Tidak ada modifier",
    locked: "Terkunci",
    needUnlock: "Beli untuk membuka",
    remaining: "Sisa {d}",
    use: "Gunakan",
    quitTitle: "Keluar game",
    quitConfirm: "Keluar dari game saat ini?",
    quitConfirmBtn: "Keluar",
    quitCancelBtn: "Lanjutkan main",
    joyNameFixed: "Tetap",
    joyNameHalfZone: "Zona setengah layar",
    joyNameFullFollow: "Ikuti layar penuh",
    joyNameDrag: "Seret",
    padConnected: "🎮 Gamepad terhubung, tombol virtual disembunyikan",
    padDisconnected: "Gamepad terputus, tombol virtual dipulihkan",
    rightStickToast: "Stik kanan: {name}",
    noEditableLayout: "Tidak ada tata letak tombol yang bisa diedit",
    timeUsedUp: "Waktu bermain habis",
    addTimeSuccess: "Waktu ditambahkan",
    submitted: "Terkirim",
    minutesShort: "{n} mnt",
    addTime: "Tambah waktu",
    expand: "Perluas",
    collapse: "Ciutkan",
    physicalPadConnected: "Gamepad fisik terhubung",
    unmute: "Bunyikan",
    mute: "Bisukan",
    fullscreen: "Layar penuh",
    summonKeyboard: "Tampilkan keyboard",
    sensoryMode: "Kontrol gerak",
    idleWarnTip: "Tidak ada aktivitas. Keluar dari game dalam {n} detik.",
    idleContinue: "Lanjutkan",
    nsInputTitle: "Game memerlukan input teks",
    nsInputHint: "Ketik teks, lalu konfirmasi",
    settings: "Pengaturan",
    currentRemaining: "Sisa {n} menit",
    exchangeBeans: "Tukar waktu dengan Caidou",
    useAddTimeCard: "Gunakan kartu tambah waktu",
  },
  drama: {
    title: "Drama Pendek", refresh: "Muat ulang", retry: "Coba lagi", loadFailed: "Drama gagal dimuat. Coba lagi.", completed: "Tamat", episodes: "{n} episode", noMore: "Tidak ada lagi", loadMore: "Muat lagi", back: "Kembali", episode: "Episode {n}", episodesLabel: "Episode", lockedTitle: "Buka episode ini", lockedBody: "Buka di aplikasi host atau tonton iklan berhadiah untuk akses terbatas.", unlockEpisode: "Buka episode", watchAd: "Tonton iklan", adUnlocked: "Episode dibuka", adUnavailable: "Iklan belum tersedia.", paymentPending: "Selesaikan pembayaran di aplikasi host.", paymentUnavailable: "Pembayaran belum tersedia.", videoUnavailable: "Video tidak tersedia.",
  },
  net: {
    requestFailed: "Permintaan gagal",
    errorWithCode: "Error {code}",
    serverError: "Error server {status}",
    timeout: "Permintaan habis waktu",
    networkError: "Kesalahan jaringan",
  },
  controls: {
    selectKeyFirst: "Pilih tombol dulu",
    saved: "Tersimpan",
    saveFailed: "Gagal menyimpan",
    selected: "Dipilih: {name}",
    keyFallback: "tombol",
    hint: "Seret untuk memindahkan; ketuk untuk atur ukuran / opasitas / aksi",
    size: "Ukuran {pct}%",
    opacity: "Opasitas {pct}%",
    operation: "Aksi",
    opPress: "Tekan",
    opDrag: "Seret",
    opLock: "Kunci",
    delete: "Hapus",
    addKey: "Tambah tombol",
    reset: "Setel ulang",
    save: "Simpan",
    addHiddenKey: "Tambah tombol tersembunyi",
    noHiddenKeys: "Tidak ada tombol tersembunyi",
  },
};

export default messages;
